<template>
    <section class="app">
        <section class="header">
            <div>
               <img src="../../assets/imgs/logo.svg" height="50">
            </div>
            <div></div>
        </section>
        <section class="body">
            <div class="login">
                <div class="title">
                    <h1>Criar conta</h1>
                </div>
                <form v-on:submit.prevent="register">
                    <h3>Dados de pessoais</h3>
                    <div class="msg" v-if="message">{{message}}</div>
                    <div class="input-box">
                        <input id="input-first-name" type="text" placeholder="Digite o seu nome" v-model="form.first_name" @focus="clearMessage">
                        <label for="input-first-name">
                            <span>Nome</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-last-name" type="text" placeholder="Digite o seu sobrenome" v-model="form.last_name" @focus="clearMessage">
                        <label for="input-last-name">
                            <span>Sobrenome</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-cpf" type="text" placeholder="Digite seu CPF" v-model="form.cpf" @focus="clearMessage" v-mask="'###.###.###-##'">
                        <label for="input-cpf">
                            <span>CPF</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-date-birth" type="text" placeholder="Data de nascimento" v-model="form.birthdate" @focus="clearMessage" v-mask="'##-##-####'">
                        <label for="input-date-birth">
                            <span>Nascimento</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-mobile" type="text" placeholder="Telefone celular" v-model="form.mobile" @focus="clearMessage" v-mask="'(##)#####-####'">
                        <label for="input-mobile">
                            <span>Celular</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-tel" type="text" placeholder="Telefone" v-model="form.phone" @focus="clearMessage"  v-mask="'(##)#####-####'">
                        <label for="input-tel">
                            <span>Telefone</span>
                        </label>
                    </div>

                    <h3>Dados de acesso</h3>

                    <div class="input-box">
                        <input id="input-email" type="text" placeholder="E-mail pessoal" v-model="form.email" @focus="clearMessage">
                        <label for="input-email">
                            <span>E-mail</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-password" type="password" placeholder="Senha de acesso" v-model="form.password" @focus="clearMessage">
                        <label for="input-password">
                            <span>Senha</span>
                        </label>
                    </div>
                    <div class="input-box">
                        <input id="input-password-repeat" type="password" placeholder="Confirme sua senha" v-model="form.password_confirm" @focus="clearMessage">
                        <label for="input-password-repeat">
                            <span>Confirmar senha</span>
                        </label>
                    </div>

                    <div class="control">
                        <button type="submit" :class="load ? 'load' : ''">Continuar</button>
                    </div>
                </form>
                <div class="link-back">
                    <router-link to="login"><i class="fal fa-long-arrow-left"></i> Ir para o login</router-link>
                </div>
            </div>
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg" height="20">
            </div>
        </section>
    </section>
</template>

<script>

    import { user } from "@/services"

    export default {
        name: 'register',
        components: {},
        data() {
            return {
                form: {
                    first_name: '',
                    last_name: '',
                    cpf: '',
                    birthdate: '',
                    mobile: '',
                    phone: '',
                    email: '',
                    password: '',
                    password_confirm: '',
                },
                load: false,
                message: '',
            }
        },
        methods: {
            register(){
                this.load = true
                user.register(this.form).then( () => {
                    this.load = false
                    this.$router.push({
                        name: 'message',
                        params: {
                            title: 'Conta criada com sucesso!',
                            text: 'O seu cadastro já está ativado. Clique no botão abaixo para logar.',
                            btnText: 'Acessar minha conta.',
                            url: 'login'
                        }
                    })
                }, error => {
                    this.message = error.response.data.message
                    this.load = false
                })
            },
            clearMessage(){
                this.message = ''
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
